import { ExamVariant } from '@/plugins/api'
import alert from '@/plugins/alert'

/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchExamVariants({ commit }, options) {
      const examVariants = await ExamVariant.fetch({ ...options })
      return examVariants
    },
    async fetchExamVariant({ commit }, id) {
      const examVariant = await ExamVariant.fetchOne(id)
      return examVariant
    },
    async createExamVariant({ commit }, data) {
      if (!data.scores) {
        data.scores = {
          part1: Array.from({ length: 20 }, () => 0.25),
          part2: [
            "1a","1b","1c","1d",
            "2a","2b","2c","2d",
            "3a","3b","3c","3d",
            "4a","4b","4c","4d",
            "5a","5b","5c","5d",
            "6a","6b","6c","6d",
            "7a","7b","7c","7d",
            "8a","8b","8c","8d"
          ].map(q => ({
            q,
            scores: [0.1, 0.25, 0.5, 1]
          })),
          part3: {
            math:   [0.5, 0.5, 0.5, 0.5, 0.5, 0.5],
            others: [0.25, 0.25, 0.25, 0.25, 0.25, 0.25]
          }
        }
      }
      const examVariant = await ExamVariant.create(data)
      return examVariant
    },
    async updateExamVariant({ commit }, { id, ...data }) {
        console.log(data)
      const updatedEV = await ExamVariant.update(id, { ...data })
      return updatedEV
    },
    async countExamVariants({ commit }, options) {
      try {
        return ExamVariant.count(options)
      } catch (e) {
        alert.error(e)
      }
    },
    async removeExamVariants({ commit }, id) {
      await ExamVariant.remove(id)
      alert.success('Bỏ đáp án thành công')
    }
  }
}
/* eslint-disable no-unused-vars */
